import { useState, useEffect } from "react";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Slide, ToastContainer } from "react-toastify";
import { Header } from "./Header";
import { SideBar } from "./SideBar";

export const AppLayout = (props: { children?: React.ReactNode }) => {
    const [sideBarOpen, setSideBarOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    
    useEffect(() => {
        const handleScroll = () => {
            const offset = window.scrollY;
            if (offset > 10) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };
        
        window.addEventListener('scroll', handleScroll);
        
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div className="flex flex-column min-h-screen">
            <div 
                className="page-container flex flex-column flex-grow-1"
                style={{ 
                    transition: "all var(--transition-speed) ease" 
                }}
            >
                <div className={`${scrolled ? 'shadow-2' : ''}`} style={{ transition: "all var(--transition-speed) ease" }}>
                    <Header onClick={() => setSideBarOpen(true)} />
                </div>

                <SideBar
                    visible={sideBarOpen}
                    onClose={() => {
                        setSideBarOpen(false);
                    }}
                />
                <section className="flex-grow-1 mx-6 py-3">{props.children}</section>

                <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    pauseOnHover
                    theme="colored"
                    transition={Slide}
                />
                <ConfirmDialog />
            </div>
        </div>
    );
};
